import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * TimeSlot Schema
 * Represents an available time slot for scheduling games
 */
export const TimeSlotSchema = z.object({
  _id: objectId,
  location: objectId,
  organization: objectId,
  league: objectId,
  tournament: objectId,
  gameDurationInMinutes: z.number().default(60),
  contestType: z.string().optional(),
  availableDate: z.string().optional(), // MM-DD-YYYY
  maxGames: z.number().optional(),
  startTime: z.string().optional(),
  endTime: z.string().optional(),
  ...timestampFields,
});

export type TimeSlot = z.infer<typeof TimeSlotSchema>;

export const timeSlotMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  location: { ref: 'Location', label: 'Location' },
  organization: { ref: 'Organization', label: 'Organization' },
  league: { ref: 'League', label: 'League' },
  tournament: { ref: 'Tournament', label: 'Tournament' },
  gameDurationInMinutes: { label: 'Game Duration (min)', editable: true },
  contestType: { label: 'Contest Type', editable: true },
  availableDate: { label: 'Available Date', editable: true },
  maxGames: { label: 'Max Games', editable: true },
  startTime: { label: 'Start Time', editable: true },
  endTime: { label: 'End Time', editable: true },
  created: { hidden: true },
  updated: { hidden: true },
};
